"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.methods = exports.initialState = void 0;
const fp = require("fp-ts");
const monocle = require("monocle-ts");
const ActionTypes = require("../../actionTypes/auth/oauth2");
exports.initialState = {
    status: 'STANDBY',
    clientStatus: 'STANDBY',
    params: null,
    clientName: fp.option.none
};
const statusLens = monocle.Lens.fromProp('status');
const clientStatusLens = monocle.Lens.fromProp('clientStatus');
const paramsLens = monocle.Lens.fromProp('params');
const clientNameLens = monocle.Lens.fromProp('clientName');
exports.methods = {};
exports.methods[ActionTypes.GET_OAUTH2_CLIENT_REQUEST] = (state, action) => clientStatusLens.set('FETCHING')(state);
exports.methods[ActionTypes.GET_OAUTH2_CLIENT_SUCCESS] = (state, action) => fp.function.compose(clientStatusLens.set('FETCHED'), clientNameLens.set(fp.option.some(action.payload.name)), statusLens.set(action.payload.scope === null ? 'VERIFY' : 'REDIRECT'))(state);
exports.methods[ActionTypes.GET_OAUTH2_CLIENT_FAILURE] = (state, action) => clientStatusLens.set('FAILURE')(state);
exports.methods[ActionTypes.SET_OAUTH2_PARAMS] = (state, action) => paramsLens.set(action.payload)(state);
//# sourceMappingURL=oauth2.js.map